import { createReducer } from 'src/helpers/reducer';
import {
  IConvertToPermanentState,
  ILoadReasonsSuccessPayload,
  ILoadConversionSuccessPayload,
  IConversionMutationSuccessPayload,
} from '../types';
import actionTypes from './actionTypes';

const initState: IConvertToPermanentState = {
  isReasonsLoading: false,
  isConversionLoading: false,
  isSubmitting: false,
  initiateSuccess: false,
  reasons: [],
  conversion: null,
  ineligibleReason: null,
};

function onLoadReasons(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isReasonsLoading: true };
}

function onLoadReasonsSuccess(
  state: IConvertToPermanentState,
  { payload }: { payload: ILoadReasonsSuccessPayload },
): IConvertToPermanentState {
  return { ...state, isReasonsLoading: false, reasons: payload.reasons };
}

function onLoadReasonsError(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isReasonsLoading: false };
}

function onLoadConversion(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isConversionLoading: true };
}

function onLoadConversionSuccess(
  state: IConvertToPermanentState,
  { payload }: { payload: ILoadConversionSuccessPayload },
): IConvertToPermanentState {
  return {
    ...state,
    isConversionLoading: false,
    conversion: payload.conversion,
    ineligibleReason: payload.ineligible_reason,
  };
}

function onLoadConversionError(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isConversionLoading: false };
}

function onSubmit(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isSubmitting: true, initiateSuccess: false };
}

function onSubmitSuccess(
  state: IConvertToPermanentState,
  { payload }: { payload: IConversionMutationSuccessPayload },
): IConvertToPermanentState {
  return { ...state, isSubmitting: false, conversion: payload.conversion };
}

function onInitiateSuccess(
  state: IConvertToPermanentState,
  { payload }: { payload: IConversionMutationSuccessPayload },
): IConvertToPermanentState {
  return { ...state, isSubmitting: false, conversion: payload.conversion, initiateSuccess: true };
}

function onSubmitError(state: IConvertToPermanentState): IConvertToPermanentState {
  return { ...state, isSubmitting: false, initiateSuccess: false };
}

function onClearStore(): IConvertToPermanentState {
  return { ...initState };
}

export default createReducer(initState, {
  [actionTypes.LOAD_REASONS]: onLoadReasons,
  [actionTypes.LOAD_REASONS_SUCCESS]: onLoadReasonsSuccess,
  [actionTypes.LOAD_REASONS_ERROR]: onLoadReasonsError,
  [actionTypes.LOAD_CONVERSION]: onLoadConversion,
  [actionTypes.LOAD_CONVERSION_SUCCESS]: onLoadConversionSuccess,
  [actionTypes.LOAD_CONVERSION_ERROR]: onLoadConversionError,
  [actionTypes.INITIATE_CONVERSION]: onSubmit,
  [actionTypes.INITIATE_CONVERSION_SUCCESS]: onInitiateSuccess,
  [actionTypes.INITIATE_CONVERSION_ERROR]: onSubmitError,
  [actionTypes.DECLINE_CONVERSION]: onSubmit,
  [actionTypes.DECLINE_CONVERSION_SUCCESS]: onSubmitSuccess,
  [actionTypes.DECLINE_CONVERSION_ERROR]: onSubmitError,
  [actionTypes.CLEAR_STORE]: onClearStore,
});
